module.exports = __webpack_public_path__ + "static/img/15.6c761c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/15.png
// module id = VDVE
// module chunks = 0